module.exports = {
  API_URL: 'http://localhost:3500'
}
